module.exports = __webpack_public_path__ + "static/Filtr_ciśnieniowy-ae91fdc8918246c116fa2574cd231dc7.png";